import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/**
 * Amber warning shown in enrollment flows when the chosen sequence has no
 * sender account: enrollments would be created but every send stays blocked.
 */
export function NoSenderWarning() {
  const { t } = useTranslation('sequences')

  return (
    <div className="rounded-md border border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-950 p-3">
      <div className="flex items-start gap-2 text-amber-700 dark:text-amber-400 text-sm">
        <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
        {t('noSender.enrollWarning')}
      </div>
    </div>
  )
}
